export const PROJECT_SHARE_BUTTON_SCOPE = 'project-share-button-global';
